module.exports = __webpack_public_path__ + "static/media/tracking-yello.afaef582.svg";